module.exports = __webpack_public_path__ + "assets/img/plan2-1.d9c80699.png";